module.exports = __webpack_public_path__ + "static/media/minus-square-new.7b942334.svg";